module.exports = __webpack_public_path__ + "img/位图(3).10f3d22c.png";